import React from 'react';
import { Button, Card, Icon } from 'antd';

import Form from './Form';

export class Control extends React.Component {
  state = {
    editing: this.props.adding,
  }

  edit = () => this.setState(({
    editing, ...state
  }) => ({
    ...state,
    editing: !editing,
  }));

  save = control => {
    const { onSave } = this.props;
    onSave(control);
    this.setState({ editing: false });
  }

  render () {
    const {
      control,
      control: {
        type,
        name,
        mandatory,
      },
      adding,
      onRemove = () => null,
      ...props
    } = this.props;
    const { editing } = this.state;
    const { edit, save } = this;

    return (
      <Card
        className="card"
        title={(
          <div className="title">
            {type === 'location'
              ? <span>Lieu de l'activité</span>
              : <span className="title__type">{type}</span>}
            {name && (<span className="title__name">{name}</span>)}
          </div>
        )}
        extra={
          mandatory
            ? (
              <span><Icon type="lock" /> non modifiable</span>
            )
            : (
              <React.Fragment>
                {!adding && (
                  <Button
                    onClick={edit}
                    icon={editing ? 'stop' : 'edit'}
                  >
                    {editing
                      ? 'Annuler'
                      : 'Modifier'
                    }
                  </Button>
                )}
                <Button
                  onClick={() => onRemove(name)}
                  type="danger"
                  icon="delete"
                >
                  Supprimer
                </Button>
              </React.Fragment>
            )
        }
      >
        {editing && (
          <div className={`control ${mandatory ? 'control--mandatory' : ''}`}>
            <div className="control__content control__content--editing">
              <Form
                control={control}
                {...props}
                onSave={save}
              />
            </div>
          </div>
        )}
      </Card>
    );
  }
}

export default Control;



// WEBPACK FOOTER //
// ./src/components/Admin/ActivitiesManagement/ActivityEdit/Control/index.js